import React from 'react';
import { Button } from "primereact/button";

export function CustomButton(props) {
    return (
        <Button
            id={props.id}
            label={props.label}
            className={`p-button-sm ${props.rounded && 'p-button-rounded'} ${props.className}`}
            onClick={props.onClick}
            type={props.type}
            icon={props.icon}
            disabled={props.disabled}
            tooltip={props.tooltip}
            style={props.style}
        />
    );
}